const translations = {
    clientNameFieldPlaceholder: 'Client',
    farmNameFieldPlaceholder: 'Farm',
    fieldNameFieldPlaceholder: 'Field',
    label: 'Client | Farm'
};

export default translations;
